var _sentryCollisionFreeGlobalObject = typeof window === "undefined" ? global : window;
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"sTlplUY_20Jz3uH9fqXxY"};
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

import * as Sentry from '@sentry/nextjs';
import config from './config';

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN || '',
  tracesSampleRate: parseFloat(process.env.NEXT_PUBLIC_CLIENT_TRACES_SAMPLE_RATE) || 0.1,
  environment: config.environment,
  sampleRate: parseFloat(process.env.NEXT_PUBLIC_CLIENT_SAMPLE_RATE) || 0.5,
  enabled: !!process.env.NEXT_PUBLIC_CLIENT_ENABLE,
});
